module.exports = __webpack_public_path__ + "img/fade_boxes.5858e0fc.png";